// Must be imported before React
// eslint-disable-next-line import/order
import { scan as runRenderScanner } from 'react-scan';

import App from './app';
import { DevTools as JotaiDevTools } from 'jotai-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

const appRoot = createRoot(document.getElementById('root') as HTMLElement);

if (import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true') {
  import('jotai-devtools/styles.css');

  // See: https://github.com/aidenybai/react-scan
  runRenderScanner({
    enabled: true,
    log: true,
  });

  appRoot.render(
    <>
      {/* See: https://jotai.org/docs/tools/devtools */}
      <JotaiDevTools />
      {/* See: https://react.dev/reference/react/StrictMode */}
      <StrictMode>
        <App />
      </StrictMode>
    </>
  );
} else {
  appRoot.render(<App />);
}
